import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IntegrationTokenWithSecret, IntegrationTokenListResponse } from '@zerops/models/integration-token';

@Injectable({ providedIn: 'root' })
export class IntegrationTokenApi {
  #httpClient = inject(HttpClient);

  // Custom /list endpoint (not standard REST pattern)
  list$(clientId: string): Observable<IntegrationTokenListResponse> {
    return this.#httpClient.get<IntegrationTokenListResponse>(
      `/api/client/${clientId}/integration-token/list`
    );
  }

  // Custom regenerate endpoint
  regenerate$(clientId: string, tokenId: string): Observable<IntegrationTokenWithSecret> {
    return this.#httpClient.put<IntegrationTokenWithSecret>(
      `/api/client/${clientId}/integration-token/${tokenId}/regenerate`,
      {}
    );
  }
}
